import React, { Component, KeyboardEvent, ChangeEvent, MouseEvent } from "react";
import {
    Row, Col, Button, Modal, ModalBody, ModalHeader, ModalFooter, Spinner, UncontrolledTooltip, Badge, NavItem, NavLink, TabPane, TabContent, Nav, UncontrolledPopover, PopoverBody
} from "reactstrap";
import * as KSLPlusAPI from "../services/KSLPlusAPI"

import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
// @ts-ignores
import BootstrapTable from 'react-bootstrap-table-next';
// @ts-ignore
import cellEditFactory from 'react-bootstrap-table2-editor';
// @ts-ignore
import paginationFactory from 'react-bootstrap-table2-paginator';
// @ts-ignore
import filterFactory, { selectFilter, textFilter } from 'react-bootstrap-table2-filter';

import { Chart } from "react-google-charts";

import { GoogleChartWrapperChartType } from "react-google-charts/dist/types";



import * as Utilities from "./Utilities"
import { VBTab } from './VBTabComp';
import { CollapseControl } from './CollapseControlComp';

import { env } from '../env';
import '../custom.css';
import { ENGINE_METHOD_PKEY_ASN1_METHS } from "constants";

import Collapse from "@kunukn/react-collapse";

type State = {
    ready: boolean,
    beschreibungActive: boolean,
    gzopen: boolean,
    vbTabsActive: boolean,
    activeKZTab: string,
    grundzahlen: KSLPlusAPI.DatensatzModel[],
    erlTextActive: boolean
}

type Props = {
    kennzahl: KSLPlusAPI.Kennzahlen,
    jahr: number,
    kunde: number,
    gemeinde: number,
    plantyp: number,
    planstufe: number,
    produkt: string,
    uhconfig: KSLPlusAPI.Uhconfig | undefined,
    bilanz: boolean,
    settings: KSLPlusAPI.SettingsModel,
    kennzahlErg: KSLPlusAPI.KennzahlModel | null,
    verwaltung: boolean
}



export class KennzahlJR extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.zeilen = [];
    }

    static defaultProps = {
        produkt: "",
        kennzahlErg: null,
        kunde: 0,
        gemeinde: 0,
        plantyp: 0,
        planstufe: 0,
        uhconfig: undefined
    }


    node: any;
    zeilen: KSLPlusAPI.KennzahlZeilenErgebnis[];
    jahre: number[] | undefined;
    dataSets: KSLPlusAPI.Datensaetze[] = [];
    vbtabs: KSLPlusAPI.Vbtab[] = [];
    grundzahlen: KSLPlusAPI.DatensatzModel[] = [];
    container: any = null;
    getFilters: { (filter: string | undefined): void }[] = [];

    createDataColumn = (field: string, jahr: number) => {


        return {
            dataField: field,
            text: jahr.toString(),
            headerAlign: 'center',
            align: 'right',
            formatter: (cellContent: string, row: KSLPlusAPI.KennzahlZeilenErgebnis) => {
                var ez = row as { [key: string]: any };
                if (!row.zeile || (!row.zeile.inkludierteGruppen || row.zeile.inkludierteGruppen.length == 0) && (!row.zeile.subtraktionsGruppen || row.zeile.subtraktionsGruppen.length == 0) && (!row.zeile.berechnung || row.zeile.berechnung.length == 0) && (!row.zeile.ds || row.zeile.ds.length == 0))
                    return null;
                return (
                    <div className="kslplus-tabellen-data">{Utilities.FormatCurrency(ez[field], row.zeile?.nachkommastellen ?? (this.props.settings.nk ?? 2), 3, '.', ',')} </div>
                );

            },
            headerStyle: (colum: any, colIndex: any) => {
                return { width: '20%' };
            },
            style: (colum: any, colIndex: any) => {
                return { width: '20%' };
            }
        };
    }

    rowClasses = (row: KSLPlusAPI.KennzahlZeilenErgebnis, rowIdx: number) => {
        if (row.istErgebnisZeile)
            return "kslplus-kennzahl-ergebnis-zeile";

        return ".kslplus-kennzahl-zeile";
    }

    createColumns = () => {
        var columns = [];


        var id = 1;
        columns.push({
            dataField: 'bezeichnung',
            text: "Bezeichnung",
            headerStyle: (colum: any, colIndex: any) => {
                return { width: '250px', textAlign: 'left' };
            },
            formatter: (cellContent: string, row: KSLPlusAPI.KennzahlZeilenErgebnis) => {
                /*
                return (
                    <div>{row.bezeichnung + " (" + row.einheit ? row.einheit : "EUR" + ")"}</div>
                );*/
                if (!row.bezeichnung || row.bezeichnung.length == 0)
                    return null;

                if (!row.zeile || (!row.zeile.inkludierteGruppen || row.zeile.inkludierteGruppen.length == 0) && (!row.zeile.subtraktionsGruppen || row.zeile.subtraktionsGruppen.length == 0) && (!row.zeile.berechnung || row.zeile.berechnung.length == 0))
                    return (<div>{row.bezeichnung}</div>);

                return (
                    <div>{row.bezeichnung + " (" + ((row.einheit ?? "" != "") && row.einheit !== "EUR" ? row.einheit : this.props.settings.waehrung) + ")"}</div>
                );

            },
        });


        if (!this.props.bilanz && (this.zeilen && this.zeilen.filter(z => z.zeile && z.zeile.gliederung && z.zeile.gliederung.length > 0).length > 0)) {
            columns.push({
                dataField: 'zeile.gliederung',
                text: this.props.settings.buchungsart === 2 ? "Produkte" : "Gliederung",
                headerStyle: (colum: any, colIndex: any) => {
                    return { width: '150px', textAlign: 'left' };
                }

            });
        }

        columns.push({
            dataField: 'gruppen',
            text: this.props.settings.buchungsart === 2 ? "Konten" : "Gruppierungen",
            headerStyle: (colum: any, colIndex: any) => {
                return { width: '150px', textAlign: 'left' };
            },
            formatter: (cellContent: string, row: KSLPlusAPI.KennzahlZeilenErgebnis) => {
                var text = "";
                if (row.zeile) {
                    if (row.zeile.inkludierteGruppen)
                        text = row.zeile.inkludierteGruppen;
                    if (row.zeile.exkludierteGruppen) {
                        text += ",!";
                        text += row.zeile.exkludierteGruppen;
                    }
                    if (row.zeile.subtraktionsGruppen) {
                        text += " abzgl. ";
                        text += row.zeile.subtraktionsGruppen;
                    }
                }

                return (
                    <div>{text}</div>
                );

            }
        });



        id++;
        if (!this.jahre || this.jahre.findIndex(d => d == this.props.jahr - 4) >= 0) {
            columns.push(this.createDataColumn("ergebnisPJM4", this.props.jahr - 4));
            id++;
        }
        if (!this.jahre || this.jahre.findIndex(d => d == this.props.jahr - 3) >= 0) {
            columns.push(this.createDataColumn("ergebnisPJM3", this.props.jahr - 3));
            id++;
        }
        if (!this.jahre || this.jahre.findIndex(d => d == this.props.jahr - 2) >= 0) {
            columns.push(this.createDataColumn("ergebnisPJM2", this.props.jahr - 2));
            id++;
        }
        if (!this.jahre || this.jahre.findIndex(d => d == this.props.jahr - 1) >= 0) {
            columns.push(this.createDataColumn("ergebnisPJM1", this.props.jahr - 1));
            id++;
        }
        if (!this.jahre || this.jahre.findIndex(d => d == this.props.jahr) >= 0) {
            columns.push(this.createDataColumn("ergebnisPJ", this.props.jahr));
            id++;
        }


        return columns;
    }


    state: State = {
        ready: false,
        beschreibungActive: false,
        activeKZTab: "tab0",
        vbTabsActive: false,
        gzopen: false,
        grundzahlen: [],
        erlTextActive: false
    }

    redrawCharts = () => {
    }

    componentDidMount() {
        window.addEventListener('resize', this.redrawCharts, false);

        if (this.props.kennzahlErg) {

            this.zeilen = this.props.kennzahlErg?.zeilen ?? [];
            this.jahre = this.props.kennzahlErg?.jahre;
            this.setState({ ready: true });
            this.readDataSets(this.props.kennzahlErg?.kennzahl?.id ?? 0, true);
        }
        else
            this.readKennzahl();
    }

    componentDidUpdate(prevProps: Props) {
        if (prevProps.uhconfig !== this.props.uhconfig)
            this.readKennzahl();

    }

    createTabItems = (tabs: KSLPlusAPI.Vbtab[]) => {
        var mainContentItems: JSX.Element[] = [];
        var mainNavItems: JSX.Element[] = [];

        for (var i = 0; i < tabs.length; i++) {
            const tabId = "tab" + i.toString();
            const tab = tabs[i];
            mainNavItems.push(
                <NavItem key={"kenav" + tabId}>
                    <NavLink active={this.state.activeKZTab === tabId} onClick={() => this.setState({ activeKZTab: tabId })} tabIndex={0} onKeyDown={(e) => { if (e.keyCode === 13) this.setState({ activeKZTab: tabId }); }}>
                        <div className="kslplus-reiter-text-hauptzeile">{tab.bezeichnung}</div>
                    </NavLink>
                </NavItem>
            );
            if (this.props.kennzahlErg && this.props.kennzahlErg.kennzahl) {
                mainContentItems.push(
                    <TabPane tabId={tabId} key={"ketab" + tabId}>
                        <VBTab modul={this.props.plantyp == 3 ? 1 : 0} tab={tabs[i]} datasets={this.dataSets} kunde={this.props.kennzahlErg.kennzahl.kunde ?? 0} gemeinde={this.props.kennzahlErg.kennzahl?.gemeinde ?? 0} jahr={this.props.kennzahlErg.kennzahl?.jahr ?? 0} settings={this.props.settings} className="kslplus-haushaltstab-wrapper-very-bottom" isVisible={this.state.activeKZTab === tabId} />
                    </TabPane>
                );
            }
            else {
                mainContentItems.push(
                    <TabPane tabId={tabId} key={"ketab" + tabId}>
                        <VBTab modul={this.props.plantyp == 3 ? 1 : 0} tab={tabs[i]} datasets={this.dataSets} kunde={this.props.kunde} gemeinde={this.props.gemeinde} jahr={this.props.jahr} settings={this.props.settings} className="kslplus-haushaltstab-wrapper-very-bottom" isVisible={this.state.activeKZTab === tabId} />
                    </TabPane>
                );
            }
        }

        return { navItems: mainNavItems, contentItems: mainContentItems };
    }

    readDataSets = (kennzahl: number, vgl: boolean) => {
        const api = env.REACT_APP_KSLPLUS_API || "https://localhost:5001";
        var client = new KSLPlusAPI.DigitalHoushold_Client(api);

        client.vBDatasets4Kennzahl(kennzahl, vgl, this.props.plantyp === 3 ? 1 : 0, "").then((sets) => {
            this.dataSets = sets;
            this.readMainTabs(kennzahl, vgl);
        }).catch(Reason => {
        });
    }

    readMainTabs = (kennzahl: number, vgl: boolean) => {
        const api = env.REACT_APP_KSLPLUS_API || "https://localhost:5001";
        var client = new KSLPlusAPI.DigitalHoushold_Client(api);

        client.vBTabs4Kennzahl(kennzahl, vgl, this.props.plantyp == 3 ? 1 : (this.props.plantyp == 4 ? 2 : 0), "").then((tabs) => {
            this.vbtabs = tabs;
            this.readGrundzahlen(kennzahl, vgl);
            this.setState({ ready: true });
        }).catch(Reason => {
        });
    }

    readGrundzahlen = (kennzahl: number, vgl: boolean) => {
        const api = env.REACT_APP_KSLPLUS_API || "https://localhost:5001";
        var client = new KSLPlusAPI.DigitalHoushold_Client(api);

        client.gZDatasets4Kennzahl(kennzahl, vgl, this.props.plantyp == 3 ? 1 : (this.props.plantyp == 4 ? 2 : 0), "").then((gz) => {
            this.getFilters = [];
            this.setState({ ready: true, grundzahlen: gz });
        }).catch(Reason => {
        });
    }




    readKennzahl = () => {
        var request = new KSLPlusAPI.KennzahlRequest();
        var kunde = 0;
        if (this.props.kunde === undefined)
            return;
        request.kunde = this.props.kunde;
        var gemeinde = 0;
        if (this.props.gemeinde === undefined)
            return;
        request.gemeinde = this.props.gemeinde;
        var jahr = 0;
        if (this.props.jahr === undefined)
            return;
        request.jahr = this.props.jahr;

        request.plantyp = this.props.plantyp;
        request.planstufe = this.props.planstufe;
        request.kennzahl = this.props.kennzahl.id;
        request.uhConfig = this.props.uhconfig ? this.props.uhconfig.id : 0;
        request.produkt = this.props.produkt;
        request.verwaltungsansicht = this.props.verwaltung;

        const api = env.REACT_APP_KSLPLUS_API || "https://localhost:5001";

        if (this.props.settings.buchungsart === 2) {
            var client = new KSLPlusAPI.DigitalHousholdDoppik_Client(api);

            client.getKennzahlErgebnisse("", request).then((res) => {
                this.zeilen = res.zeilen ? res.zeilen : [];
                this.jahre = res.jahre;
                this.readDataSets(this.props.kennzahl?.id ?? 0, false);
                this.setState({ ready: true });
            }).catch(Reason => {
            });
        }
        else {
            var client1 = new KSLPlusAPI.DigitalHoushold_Client(api);

            client1.getKennzahlErgebnisse("", request).then((res) => {
                this.zeilen = res.zeilen ? res.zeilen : [];
                this.jahre = res.jahre;
                this.readDataSets(this.props.kennzahl?.id ?? 0, false);
                this.setState({ ready: true });
            }).catch(Reason => {
            });
        }


    }

    createGraphData = (zeile: KSLPlusAPI.KennzahlZeilenErgebnis, min: any[], max: any[]) => {
        var grdata: any[] = [];
        //grdata.push([headerX, headerY]);



        var x: number[] = [];

        var header = ["Jahr"];        
        var bez = (zeile.bezeichnung ? zeile.bezeichnung : "") + " (" + ((zeile.einheit ?? "") !== "" && zeile.einheit !== "EUR" ? zeile.einheit : this.props.settings.waehrung) + ")";
        header.push(bez);

        if (zeile.darstellung == 4 || zeile.darstellung == 5)
            header.push("Veränderung (%)");

        grdata.push(header);

        var vorWert: number | undefined = undefined;

        if ((!this.jahre || this.jahre.findIndex(d => d == this.props.jahr - 4) >= 0) && zeile.ergebnisPJM4 !== undefined) {
            var row: any[] = [(this.props.jahr - 4).toString()];
            row.push(zeile.ergebnisPJM4);
            if (zeile.darstellung == 4 || zeile.darstellung == 5)
                row.push(100);
            vorWert = zeile.ergebnisPJM4;
            grdata.push(row);
        }

        if ((!this.jahre || this.jahre.findIndex(d => d == this.props.jahr - 3) >= 0) && zeile.ergebnisPJM3 !== undefined) {
            var row: any[] = [(this.props.jahr - 3).toString()];
            row.push(zeile.ergebnisPJM3);
            if (zeile.darstellung == 4 || zeile.darstellung == 5) {
                if (vorWert === undefined)
                    row.push(100);
                else
                    row.push(zeile.ergebnisPJM3 / vorWert * 100);
            }
            vorWert = zeile.ergebnisPJM3;
            grdata.push(row);
        }

        if ((!this.jahre || this.jahre.findIndex(d => d == this.props.jahr - 2) >= 0) && zeile.ergebnisPJM2 !== undefined) {
            var row: any[] = [(this.props.jahr - 2).toString()];
            row.push(zeile.ergebnisPJM2);
            if (zeile.darstellung == 4 || zeile.darstellung == 5) {
                if (vorWert === undefined)
                    row.push(100);
                else
                    row.push(zeile.ergebnisPJM2 / vorWert * 100);
            }
            vorWert = zeile.ergebnisPJM2;
            grdata.push(row);
        }

        if ((!this.jahre || this.jahre.findIndex(d => d == this.props.jahr - 1) >= 0) && zeile.ergebnisPJM1 !== undefined) {
            var row: any[] = [(this.props.jahr - 1).toString()];
            row.push(zeile.ergebnisPJM1);
            if (zeile.darstellung == 4 || zeile.darstellung == 5) {
                if (vorWert === undefined)
                    row.push(100);
                else
                    row.push(zeile.ergebnisPJM1 / vorWert * 100);
            }
            vorWert = zeile.ergebnisPJM1;
            grdata.push(row);
        }

        if ((!this.jahre || this.jahre.findIndex(d => d == this.props.jahr) >= 0) && zeile.ergebnisPJ !== undefined) {
            var row: any[] = [this.props.jahr.toString()];
            row.push(zeile.ergebnisPJ);
            if (zeile.darstellung == 4 || zeile.darstellung == 5) {
                if (vorWert === undefined)
                    row.push(100);
                else
                    row.push(zeile.ergebnisPJ / vorWert * 100);
            }
            vorWert = zeile.ergebnisPJ;
            grdata.push(row);
        }

        for (var i = 1; i < grdata.length; i++) {
            for (var j = 1; j < grdata[i].length; j = j + 2) {
                if (grdata[i][j] < min[0])
                    min[0] = grdata[i][j];
                if (grdata[i][j] > max[0])
                    max[0] = grdata[i][j];
                if (grdata[i][j + 1] < min[1])
                    min[1] = grdata[i][j + 1];
                if (grdata[i][j + 1] > max[1])
                    max[1] = grdata[i][j + 1];
            }

        }

        return grdata;
    }

    createZusatzGraphData = (zeile: KSLPlusAPI.KennzahlZeilenErgebnis, min: any[], max: any[]) => {
        var grdata: any[] = [];
        //grdata.push([headerX, headerY]);



        var x: number[] = [];

        var header = ["Jahr"];
        var bez = (zeile.bezeichnungZusatzangabe ? zeile.bezeichnungZusatzangabe : zeile.bezeichnung);        
        header.push(bez + " (" + ((zeile.einheit ?? "") !== "" && zeile.einheit !== "EUR" ? zeile.einheit : this.props.settings.waehrung) + ")");


        if (zeile.darstellung == 4 || zeile.darstellung == 5)
            header.push("Veränderung (%)");

        grdata.push(header);

        var vorWert: number | undefined = undefined;
        if ((!this.jahre || this.jahre.findIndex(d => d == this.props.jahr - 4) >= 0) && zeile.ergebnisPJM4_Z !== undefined) {
            var row: any[] = [(this.props.jahr - 4).toString()];
            row.push(zeile.ergebnisPJM4_Z);
            if (zeile.darstellung == 4 || zeile.darstellung == 5)
                row.push(100);
            vorWert = zeile.ergebnisPJM4_Z;
            grdata.push(row);
        }

        if ((!this.jahre || this.jahre.findIndex(d => d == this.props.jahr - 3) >= 0) && zeile.ergebnisPJM3_Z !== undefined) {
            var row: any[] = [(this.props.jahr - 3).toString()];
            row.push(zeile.ergebnisPJM3_Z);
            if (zeile.darstellung == 4 || zeile.darstellung == 5) {
                if (vorWert === undefined)
                    row.push(100);
                else
                    row.push(zeile.ergebnisPJM3_Z / vorWert * 100);
            }
            vorWert = zeile.ergebnisPJM3_Z;
            grdata.push(row);
        }

        if ((!this.jahre || this.jahre.findIndex(d => d == this.props.jahr - 2) >= 0) && zeile.ergebnisPJM2_Z !== undefined) {
            var row: any[] = [(this.props.jahr - 2).toString()];
            row.push(zeile.ergebnisPJM2_Z);
            if (zeile.darstellung == 4 || zeile.darstellung == 5) {
                if (vorWert === undefined)
                    row.push(100);
                else
                    row.push(zeile.ergebnisPJM2_Z / vorWert * 100);
            }
            vorWert = zeile.ergebnisPJM2_Z;
            grdata.push(row);
        }

        if ((!this.jahre || this.jahre.findIndex(d => d == this.props.jahr - 1) >= 0) && zeile.ergebnisPJM1_Z !== undefined) {
            var row: any[] = [(this.props.jahr - 1).toString()];
            row.push(zeile.ergebnisPJM1_Z);
            if (zeile.darstellung == 4 || zeile.darstellung == 5) {
                if (vorWert === undefined)
                    row.push(100);
                else
                    row.push(zeile.ergebnisPJM1_Z / vorWert * 100);
            }
            vorWert = zeile.ergebnisPJM1_Z;
            grdata.push(row);
        }

        if ((!this.jahre || this.jahre.findIndex(d => d == this.props.jahr) >= 0) && zeile.ergebnisPJ_Z !== undefined) {
            var row: any[] = [this.props.jahr.toString()];
            row.push(zeile.ergebnisPJ_Z);
            if (zeile.darstellung == 4 || zeile.darstellung == 5) {
                if (vorWert === undefined)
                    row.push(100);
                else
                    row.push(zeile.ergebnisPJ_Z / vorWert * 100);
            }
            vorWert = zeile.ergebnisPJ_Z;
            grdata.push(row);
        }

        for (var i = 1; i < grdata.length; i++) {
            for (var j = 1; j < grdata[i].length; j = j + 2) {
                if (grdata[i][j] < min[0])
                    min[0] = grdata[i][j];
                if (grdata[i][j] > max[0])
                    max[0] = grdata[i][j];
                if (grdata[i][j + 1] < min[1])
                    min[1] = grdata[i][j + 1];
                if (grdata[i][j + 1] > max[1])
                    max[1] = grdata[i][j + 1];
            }

        }



        return grdata;
    }

    createSammelGraphData = (zusatz: boolean, min: any[], max: any[]) => {
        var grdata: any[] = [];
        var axisItems: any[] = [];
        var einheit: string[] = [""];
        //grdata.push([headerX, headerY]);



        var x: number[] = [];
        var header = ["Jahr"];

        const darstellung = this.props.kennzahl.darstellung;

        for (var i = 0; i < this.zeilen.length; i++) {
            const zeile = this.zeilen[i];

            if (!zusatz && (zeile.darstellung === undefined || zeile.darstellung >= 1))
                continue;

            if (zusatz && (zeile.darstellungZusatzangabe === undefined || zeile.darstellungZusatzangabe >= 1))
                continue;

            var bez = zeile.bezeichnung;
            if (zusatz)
                bez = (zeile.bezeichnungZusatzangabe ? zeile.bezeichnungZusatzangabe : zeile.bezeichnung);
            
            header.push(bez + " (" + ((zeile.einheit ?? "") !== "" && zeile.einheit !== "EUR" ? zeile.einheit : this.props.settings.waehrung) + ")");

            if (this.props.kennzahl.darstellung == 4 || this.props.kennzahl.darstellung == 5)
                header.push("Veränderung " + bez + " (%)");
        }

        grdata.push(header);

        var row1: any[] = [(this.props.jahr - 4).toString()];
        var row2: any[] = [(this.props.jahr - 3).toString()];
        var row3: any[] = [(this.props.jahr - 2).toString()];
        var row4: any[] = [(this.props.jahr - 1).toString()];
        var row5: any[] = [this.props.jahr.toString()];

        for (var i = 0; i < this.zeilen.length; i++) {
            const zeile = this.zeilen[i];
            
            einheit.push(((zeile.einheit ?? "") != "" && zeile.einheit !== "EUR") ? zeile.einheit ?? "" : this.props.settings.waehrung ?? "EUR");
            if (darstellung == 4 || darstellung == 5)
                einheit.push("%");

            var vorWert: number | undefined = undefined;

            if (zusatz) {
                if (zeile.darstellungZusatzangabe === undefined || zeile.darstellungZusatzangabe >= 1)
                    continue;

                if ((!this.jahre || this.jahre.findIndex(d => d == this.props.jahr - 4) >= 0) && zeile.ergebnisPJM4_Z !== undefined) {
                    row1.push(zeile.ergebnisPJM4_Z);
                    if (darstellung == 4 || darstellung == 5)
                        row1.push(100);
                    vorWert = zeile.ergebnisPJM4;
                }

                if ((!this.jahre || this.jahre.findIndex(d => d == this.props.jahr - 3) >= 0) && zeile.ergebnisPJM3_Z !== undefined && zeile.ergebnisPJM3_Z !== null) {
                    row2.push(zeile.ergebnisPJM3_Z);
                    if (darstellung == 4 || darstellung == 5) {
                        if (vorWert === undefined)
                            row2.push(100);
                        else
                            row2.push(zeile.ergebnisPJM3_Z / vorWert * 100);
                    }
                    vorWert = zeile.ergebnisPJM3_Z;
                }

                if ((!this.jahre || this.jahre.findIndex(d => d == this.props.jahr - 2) >= 0) && zeile.ergebnisPJM2_Z !== undefined && zeile.ergebnisPJM2_Z !== null) {
                    row3.push(zeile.ergebnisPJM2_Z);
                    if (darstellung == 4 || darstellung == 5) {
                        if (vorWert === undefined)
                            row3.push(100);
                        else
                            row3.push(zeile.ergebnisPJM2_Z / vorWert * 100);
                    }
                    vorWert = zeile.ergebnisPJM2_Z;
                }

                if ((!this.jahre || this.jahre.findIndex(d => d == this.props.jahr - 1) >= 0) && zeile.ergebnisPJM1_Z !== undefined && zeile.ergebnisPJM1_Z !== null) {
                    row4.push(zeile.ergebnisPJM1_Z);
                    if (darstellung == 4 || darstellung == 5) {
                        if (vorWert === undefined)
                            row4.push(100);
                        else
                            row4.push(zeile.ergebnisPJM1_Z / vorWert * 100);
                    }
                    vorWert = zeile.ergebnisFp1_Z;
                }

                if ((!this.jahre || this.jahre.findIndex(d => d == this.props.jahr) >= 0) && zeile.ergebnisPJ_Z !== undefined && zeile.ergebnisPJ_Z !== null) {
                    row5.push(zeile.ergebnisPJ_Z);
                    if (darstellung == 4 || darstellung == 5) {
                        if (vorWert === undefined)
                            row5.push(100);
                        else
                            row5.push(zeile.ergebnisPJ_Z / vorWert * 100);
                    }
                    vorWert = zeile.ergebnisPJ_Z;
                }


            }
            else {
                if (zeile.darstellung === undefined || zeile.darstellung >= 1)
                    continue;

                if ((!this.jahre || this.jahre.findIndex(d => d == this.props.jahr - 4) >= 0) && zeile.ergebnisPJM4 !== undefined) {
                    row1.push(zeile.ergebnisPJM4);
                    if (darstellung == 4 || darstellung == 5)
                        row1.push(100);
                    vorWert = zeile.ergebnisPJM4;
                }

                if ((!this.jahre || this.jahre.findIndex(d => d == this.props.jahr - 3) >= 0) && zeile.ergebnisPJM3 !== undefined) {
                    row2.push(zeile.ergebnisPJM3);
                    if (darstellung == 4 || darstellung == 5) {
                        if (vorWert === undefined)
                            row2.push(100);
                        else
                            row2.push(zeile.ergebnisPJM3 / vorWert * 100);
                    }
                    vorWert = zeile.ergebnisPJM3;
                }

                if ((!this.jahre || this.jahre.findIndex(d => d == this.props.jahr - 2) >= 0) && zeile.ergebnisPJM2 !== undefined) {
                    row3.push(zeile.ergebnisPJM2);
                    if (darstellung == 4 || darstellung == 5) {
                        if (vorWert === undefined)
                            row3.push(100);
                        else
                            row3.push(zeile.ergebnisPJM2 / vorWert * 100);
                    }
                    vorWert = zeile.ergebnisPJM2;
                }

                if ((!this.jahre || this.jahre.findIndex(d => d == this.props.jahr - 1) >= 0) && zeile.ergebnisPJM1 !== undefined) {
                    row4.push(zeile.ergebnisPJM1);
                    if (darstellung == 4 || darstellung == 5) {
                        if (vorWert === undefined)
                            row4.push(100);
                        else
                            row4.push(zeile.ergebnisPJM1 / vorWert * 100);
                    }
                    vorWert = zeile.ergebnisPJM1;
                }

                if ((!this.jahre || this.jahre.findIndex(d => d == this.props.jahr) >= 0) && zeile.ergebnisPJ !== undefined) {
                    row5.push(zeile.ergebnisPJ);
                    if (darstellung == 4 || darstellung == 5) {
                        if (vorWert === undefined)
                            row5.push(100);
                        else
                            row5.push(zeile.ergebnisPJ / vorWert * 100);
                    }
                    vorWert = zeile.ergebnisPJ;
                }


            }
        }

        if (row1.length > 1)
            grdata.push(row1);

        if (row2.length > 1)
            grdata.push(row2);

        if (row3.length > 1)
            grdata.push(row3);

        if (row4.length > 1)
            grdata.push(row4);

        if (row5.length > 1)
            grdata.push(row5);

        for (var i = 1; i < grdata.length; i++) {
            for (var j = 1; j < grdata[i].length; j = j + 1) {
                if (einheit[j] !== "%") {
                    if (grdata[i][j] < min[0])
                        min[0] = grdata[i][j];
                    if (grdata[i][j] > max[0])
                        max[0] = grdata[i][j];
                }
                else {
                    if (grdata[i][j] < min[1])
                        min[1] = grdata[i][j];
                    if (grdata[i][j] > max[1])
                        max[1] = grdata[i][j];
                }
            }

        }

        return grdata;
    }

    createGraphItems = () => {
        var items = [];

        for (var i = 0; i < this.zeilen.length; i++) {
            const zeile = this.zeilen[i];
            if (zeile === undefined || zeile.darstellung === undefined || zeile.darstellung < 2)
                continue;

            var max: any[] = [-Number.MAX_VALUE, -Number.MAX_VALUE];
            var min: any[] = [Number.MAX_VALUE, Number.MAX_VALUE];
            var data = this.createGraphData(zeile, min, max);
            var trendHidden = this.props.settings.trendlinieAnzeigen === false;
            var graphOpt = Utilities.calcGrapOptions(min, max, this.props.settings.nullAchseAnzeigen);

            items.push(
                <div key={"gritem" + i.toString()}>
                    <Row>
                        <Col>
                            <div className="kslplus-headline-third">Entwicklung {zeile.bezeichnung}</div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>

                            <div className="ksl-grafik-container">
                                <Chart
                                    width="100%"
                                    height={'300px'}
                                    chartType="ComboChart"
                                    chartLanguage='de'
                                    loader={<div>Loading Chart</div>}
                                    data={Utilities.filterTrendlineData(data, this.props.settings.trendlinieAnzeigen)}
                                    options={{
                                        colors: ['#264d99', '#ADD8E6', '#dc8e12', '#f8b344'],
                                        vAxes: { 0: { title: (zeile.einheit ?? "") !== "" && zeile.einheit !== "EUR" ? zeile.einheit : this.props.settings.waehrung, minValue: graphOpt.minG, maxValue: graphOpt.maxG, viewWindow: { max: graphOpt.max0, min: graphOpt.min0 } }, 1: trendHidden ? { ...Utilities.hiddenAxis, minValue: graphOpt.minG, maxValue: graphOpt.maxG, viewWindow: { max: graphOpt.max1, min: graphOpt.min1 } } : { title: "%", minValue: graphOpt.minG, maxValue: graphOpt.maxG, viewWindow: { max: graphOpt.max1, min: graphOpt.min1 } } },
                                        hAxis: { title: 'Jahr', format: "####" },
                                        series: Utilities.applyTrendlineHiding({ 0: { type: zeile.darstellung == 3 || zeile.darstellung == 5 ? "bars" : "line", targetAxisIndex: 0 }, 1: { type: "line", targetAxisIndex: 1 } }, trendHidden)
                                    }}
                                    formatters={Utilities.createFormatters((zeile.darstellung == 2 || zeile.darstellung == 3) ? 1 : 2, 2)}

                                    rootProps={{ 'data-testid': '2' }}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
            );
        }


        return items;
    }

    createZusatzGraphItems = () => {
        var items = [];

        for (var i = 0; i < this.zeilen.length; i++) {
            const zeile = this.zeilen[i];
            if (zeile === undefined || zeile.darstellungZusatzangabe === undefined || zeile.darstellungZusatzangabe < 2)
                continue;

            var max: any[] = [-Number.MAX_VALUE, -Number.MAX_VALUE];
            var min: any[] = [Number.MAX_VALUE, Number.MAX_VALUE];
            var data = this.createZusatzGraphData(zeile, min, max);
            var trendHidden = this.props.settings.trendlinieAnzeigen === false;
            var graphOpt = Utilities.calcGrapOptions(min, max, this.props.settings.nullAchseAnzeigen);

            items.push(
                <div key={"zgritem" + i.toString()}>
                    <Row>
                        <Col>
                            <div className="kslplus-headline-third">{"Entwicklung " + (zeile.bezeichnungZusatzangabe ? zeile.bezeichnungZusatzangabe : zeile.bezeichnung)}</div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>

                            <div className="ksl-grafik-container">
                                <Chart
                                    width="100%"
                                    height={'300px'}
                                    chartType="ComboChart"
                                    chartLanguage='de'
                                    loader={<div>Loading Chart</div>}
                                    data={Utilities.filterTrendlineData(data, this.props.settings.trendlinieAnzeigen)}
                                    options={{
                                        colors: ['#264d99', '#ADD8E6', '#dc8e12', '#f8b344'],
                                        vAxes: { 0: { title: (zeile.einheit ?? "") !== "" && zeile.einheit !== "EUR" ? zeile.einheit : this.props.settings.waehrung, minValue: graphOpt.minG, maxValue: graphOpt.maxG, viewWindow: { max: graphOpt.max0, min: graphOpt.min0 } }, 1: trendHidden ? { ...Utilities.hiddenAxis, minValue: graphOpt.minG, maxValue: graphOpt.maxG, viewWindow: { max: graphOpt.max1, min: graphOpt.min1 } } : { title: "%", minValue: graphOpt.minG, maxValue: graphOpt.maxG, viewWindow: { max: graphOpt.max1, min: graphOpt.min1 } } },
                                        hAxis: { title: 'Jahr', format: "####" },
                                        seriesType: 'bars',
                                        series: Utilities.applyTrendlineHiding({ 0: { type: zeile.darstellungZusatzangabe == 3 || zeile.darstellungZusatzangabe == 5 ? "bars" : "line", targetAxisIndex: 0 }, 1: { type: "line", targetAxisIndex: 1 } }, trendHidden)
                                    }}
                                    formatters={Utilities.createFormatters((zeile.darstellungZusatzangabe == 2 || zeile.darstellungZusatzangabe == 3) ? 1 : 2, 2)}


                                    rootProps={{ 'data-testid': '7' }}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
            );
        }


        return items;
    }



    createSammelGraphItems = (zusatz: boolean) => {
        var items: any[] = [];

        if (!zusatz && this.props.kennzahl.darstellung !== undefined && this.props.kennzahl.darstellung > 1) {
            var series: any = {};
            var idx = 0;
            var trendHidden = this.props.settings.trendlinieAnzeigen === false;

            var max: any[] = [-Number.MAX_VALUE, -Number.MAX_VALUE];
            var min: any[] = [Number.MAX_VALUE, Number.MAX_VALUE];
            var data = this.createSammelGraphData(false, min, max);
            var graphOpt = Utilities.calcGrapOptions(min, max, this.props.settings.nullAchseAnzeigen);

            for (var i = 0; i < this.zeilen.length; i++) {
                const zeile = this.zeilen[i];
                if (zeile.darstellung === undefined || zeile.darstellung >= 1)
                    continue;


                if (!zeile.darstellung)
                    series[idx] = { type: this.props.kennzahl.darstellung == 3 || this.props.kennzahl.darstellung == 5 ? "bars" : "line", targetAxisIndex: zeile.einheit === "%" ? 1 : 0 };
                else
                    series[idx] = { type: this.props.kennzahl.darstellung == 3 || this.props.kennzahl.darstellung == 5 ? "bars" : "line", targetAxisIndex: 0 };
                idx++;
                if (this.props.kennzahl.darstellung == 4 || this.props.kennzahl.darstellung == 5) {
                    series[idx] = { type: "line", targetAxisIndex: 1 };
                    idx++;

                }
            }
            series = Utilities.applyTrendlineHiding(series, trendHidden);

            items.push(
                <div key="sgritem1">
                    <Row>
                        <Col>
                            <div className="kslplus-headline-third">{this.props.kennzahl.bezeichnungDarstellung}</div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>

                            <div className="ksl-grafik-container">
                                <Chart
                                    width="100%"
                                    height={'300px'}
                                    chartType="ComboChart"
                                    chartLanguage='de'
                                    loader={<div>Loading Chart</div>}
                                    data={Utilities.filterTrendlineData(data, this.props.settings.trendlinieAnzeigen)}
                                    options={{
                                        colors: ['#264d99', '#ADD8E6', '#dc8e12', '#f8b344'],
                                        vAxes: { 0: { title: this.props.settings.waehrung, minValue: graphOpt.minG, maxValue: graphOpt.maxG, viewWindow: { max: graphOpt.max0, min: graphOpt.min0 } }, 1: trendHidden ? { ...Utilities.hiddenAxis, minValue: graphOpt.minG, maxValue: graphOpt.maxG, viewWindow: { max: graphOpt.max1, min: graphOpt.min1 } } : { title: "%", minValue: graphOpt.minG, maxValue: graphOpt.maxG, viewWindow: { max: graphOpt.max1, min: graphOpt.min1 } } },
                                        hAxis: { title: 'Jahr', format: "####" },
                                        series: series
                                    }}
                                    formatters={Utilities.createFormatters(idx, 2)}

                                    rootProps={{ 'data-testid': '2' }}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
            );
        }

        if (zusatz && this.props.kennzahl.darstellungZusatzangaben !== undefined && this.props.kennzahl.darstellungZusatzangaben > 1) {
            var series: any = {};
            var idx = 0;
            var trendHidden = this.props.settings.trendlinieAnzeigen === false;

            var max: any[] = [-Number.MAX_VALUE, -Number.MAX_VALUE];
            var min: any[] = [Number.MAX_VALUE, Number.MAX_VALUE];
            var data = this.createSammelGraphData(true, min, max);
            var graphOpt = Utilities.calcGrapOptions(min, max, this.props.settings.nullAchseAnzeigen);

            for (var i = 0; i < this.zeilen.length; i++) {
                const zeile = this.zeilen[i];
                if (zeile.darstellungZusatzangabe === undefined || zeile.darstellungZusatzangabe >= 1)
                    continue;

                series[idx] = { type: this.props.kennzahl.darstellungZusatzangaben == 3 || this.props.kennzahl.darstellungZusatzangaben == 5 ? "bars" : "line", targetAxisIndex: 0 };
                idx++;

                if (this.props.kennzahl.darstellungZusatzangaben == 4 || this.props.kennzahl.darstellungZusatzangaben == 5) {
                    series[idx] = { type: "line", targetAxisIndex: 1 };
                    idx++;

                }


            }
            series = Utilities.applyTrendlineHiding(series, trendHidden);

            items.push(
                <div key="sgritem2">
                    <Row>
                        <Col>
                            <div className="kslplus-headline-third">{this.props.kennzahl.bezeichnungDarstellungZusatzangaben}</div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>

                            <div className="ksl-grafik-container">
                                <Chart
                                    width="100%"
                                    height={'300px'}
                                    chartType="ComboChart"
                                    chartLanguage='de'
                                    loader={<div>Loading Chart</div>}
                                    data={Utilities.filterTrendlineData(data, this.props.settings.trendlinieAnzeigen)}
                                    options={{
                                        colors: ['#264d99', '#ADD8E6', '#dc8e12', '#f8b344'],
                                        vAxes: { 0: { title: this.props.settings.waehrung, minValue: graphOpt.minG, maxValue: graphOpt.maxG, viewWindow: { max: graphOpt.max0, min: graphOpt.min0 } }, 1: trendHidden ? { ...Utilities.hiddenAxis, minValue: graphOpt.minG, maxValue: graphOpt.maxG, viewWindow: { max: graphOpt.max0, min: graphOpt.min0 } } : { title: "%", minValue: graphOpt.minG, maxValue: graphOpt.maxG, viewWindow: { max: graphOpt.max0, min: graphOpt.min0 } } },
                                        hAxis: { title: 'Jahr', format: "####" },
                                        series: series
                                    }}
                                    formatters={Utilities.createFormatters(idx, 2)}

                                    rootProps={{ 'data-testid': '3' }}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
            );
        }


        return items;
    }


    getEbenenFilterOptions = () => {
        var items: { value: string, label: string }[] = [];

        this.state.grundzahlen.map(gz => {
            if (items.findIndex(i => i.value === gz.gzEbeneBez) == -1)
                items.push({ value: gz.gzEbeneBez ?? "", label: gz.gzEbeneBez ?? "" });
        });

        return items;

    }

    createGZColumns = (sets: KSLPlusAPI.DatensatzModel[]) => {
        var columns = [];

        columns.push(
            {
                dataField: 'gzEbeneBez',
                text: 'Typ',
                filter: selectFilter({
                    options: () => { return this.getEbenenFilterOptions() },
                    getFilter: (filter: any) => { this.getFilters.push(filter) }

                }),
                headerStyle: (colum: any, colIndex: any) => {
                    return { width: '220px' };
                }
            }
        );

        columns.push(
            {
                dataField: 'bezeichnung',
                text: 'Bezeichnung',
                filter: textFilter({
                    getFilter: (filter: any) => { this.getFilters.push(filter) }
                }),
                headerStyle: (colum: any, colIndex: any) => {
                    return { width: '220px' };
                }
            }
        );

        if (!this.jahre || this.jahre.length === 0 || sets.length === 0)
            return columns;

        var jMax = sets[0].datens ? (sets[0].datens[sets[0].datens.length - 1].x ?? 0) : 0;
        var jMin = sets[0].datens ? (sets[0].datens[0].x ?? 0) : 0;

        var idx = 0;
        for (var j = jMin; j <= jMax; j++) {
            const idx1 = idx;
            columns.push(
                {
                    index: idx,
                    dataField: 'datens[' + idx.toString() + '].y',
                    text: j.toString(),
                    headerStyle: (colum: any, colIndex: any) => {
                        return { width: '120px' };
                    },
                    formatter: (cellContent: string, row: KSLPlusAPI.DatensatzModel) => {

                        if (row.datens && idx1 < row.datens.length && row.datens[idx1].y !== undefined && row.datens[idx1].id)
                            return (
                                <div>{Utilities.FormatCurrency(row.datens[idx1].y, row.nachkommastellen ?? (this.props.settings.nk ?? 2), 0, '.', ',')}</div>
                            );
                    }

                }
            );
            idx++;
        }



        return columns;
    };

    setGrundzahlenVisState = () => {

        this.setState({ gzopen: !this.state.gzopen });
        this.getFilters.forEach(fct => fct(""));
    };

    createGZItem = () => {
        if (this.state.grundzahlen.length === 0)
            return null;


        if (!this.jahre || this.jahre.length === 0)
            return null;

        var jMax = this.props.jahr - 7;
        var jMin = this.props.jahr + 5;
        var sets = this.state.grundzahlen;

        sets.forEach(s => {
            s.datens = s.datens?.sort((d1, d2) => (d1.x ?? 0) - (d2.x ?? 0)).filter(d => (d.x ?? 0) > this.props.jahr - 7 && (d.x ?? 0) < this.props.jahr + 5);

            s.datens?.forEach(d => {
                if ((d?.x ?? 0) > jMax)
                    jMax = d?.x ?? 0;

                if ((d?.x ?? 0) < jMin)
                    jMin = d?.x ?? 0;

            });
        });


        sets.forEach(s => {
            for (var j = jMax; j >= jMin; j--) {
                if (s.datens?.find(d => d.x === j) === undefined) {
                    var nd = new KSLPlusAPI.Daten();
                    nd.x = j;
                    nd.y = 0;
                    s.datens?.push(nd);
                }

            }
            s.datens = s.datens?.sort((d1, d2) => (d1.x ?? 0) - (d2.x ?? 0)).filter(d => (d?.x ?? 0) >= jMin && (d?.x ?? 0) <= jMax);
        });


        this.state.grundzahlen = sets.filter(s => (s.datens?.length ?? 0) > 0);

        if (this.state.grundzahlen.length === 0)
            return null;

        //return <BootstrapTable wrapperClasses="kslplus-gzebenen-data" keyField='id' data={this.state.grundzahlen} columns={this.createGZColumns(this.state.grundzahlen)} filter={filterFactory()} filterPosition="top" />;

        return (
            <div>
                <button
                    className={"kslplus-beschreibung-toggle" + (this.state.gzopen ? " active" : "")}
                    onClick={() => this.setGrundzahlenVisState()}>
                    <div className="kslplus-beschreibung-text">
                        Grundzahlen
                    </div>
                    <div className="rotate90">
                        <svg
                            className={"kslplus-beschreibung-icon" + (this.state.gzopen ? " expanded" : "")}
                            viewBox="6 0 12 24"
                        >
                            <polygon points="8 0 6 1.8 14.4 12 6 22.2 8 24 18 12" />
                        </svg>
                    </div>

                </button>


                <Collapse
                    isOpen={this.state.gzopen}
                    className={"kslplus-collapse-gradient " + (this.state.gzopen ? " active" : "")}>

                    <BootstrapTable wrapperClasses="kslplus-gzebenen-data" keyField='id' data={this.state.grundzahlen} columns={this.createGZColumns(this.state.grundzahlen)} filter={filterFactory()} filterPosition="top" />
                </Collapse>
            </div>

        );

    }





    render() {

        var sammelgraphItems = this.createSammelGraphItems(false);
        var zusatzsammelgraphItems = this.createSammelGraphItems(true);
        var graphItems = this.createGraphItems();
        var zusatzgraphItems = this.createZusatzGraphItems();
        var tabItems = this.createTabItems(this.vbtabs);

        return (

            <div>
                <div className="kslplus-content">
                    {
                        this.zeilen.length > 0 &&
                        <div>
                            {this.props.kennzahl.beschreibung &&
                                <div>
                                    <button className={"kslplus-beschreibung-toggle" + (this.state.beschreibungActive ? " active" : "")} onClick={() => this.setState({ beschreibungActive: !this.state.beschreibungActive })} >
                                        <span className="kslplus-beschreibung-text">Beschreibung</span>
                                        <div className="rotate90">
                                            <svg
                                                className={"kslplus-beschreibung-icon" + (this.state.beschreibungActive ? " expanded" : "")}
                                                viewBox="6 0 12 24"
                                            >
                                                <polygon points="8 0 6 1.8 14.4 12 6 22.2 8 24 18 12" />
                                            </svg>
                                        </div>

                                    </button>
                                    <Collapse isOpen={this.state.beschreibungActive} className={"kslplus-beschreibung-collapse-gradient " + (this.state.beschreibungActive ? " active" : "")}>
                                        <Row>
                                            <Col className={"kslplus-beschreibung-content" + (this.props.kennzahlErg ? " kslplus-ke-vgl-bk" : "")}>
                                                {this.props.kennzahl.beschreibung != null ? this.props.kennzahl.beschreibung : ""}
                                            </Col>
                                        </Row>
                                    </Collapse>
                                </div>
                            }
                            <Row>
                                <Col>
                                    <BootstrapTable hover={true} bordered={true} keyField='id' data={this.zeilen} columns={this.createColumns()} rowClasses={this.rowClasses} />

                                </Col>
                            </Row>
                            {this.props.kennzahl.erlTextVgl && this.props.kennzahlErg &&
                                <div>
                                    <button className={"kslplus-beschreibung-toggle" + (this.state.erlTextActive ? " active" : "")} onClick={() => this.setState({ erlTextActive: !this.state.erlTextActive })} >
                                        <span className="kslplus-beschreibung-text">Erläuterungen</span>
                                        <div className="rotate90">
                                            <svg
                                                className={"kslplus-beschreibung-icon" + (this.state.erlTextActive ? " expanded" : "")}
                                                viewBox="6 0 12 24"
                                            >
                                                <polygon points="8 0 6 1.8 14.4 12 6 22.2 8 24 18 12" />
                                            </svg>
                                        </div>

                                    </button>
                                    <Collapse isOpen={this.state.erlTextActive} className={"kslplus-collapse-gradient " + (this.state.erlTextActive ? " active" : "")}>
                                        <Row>
                                            <Col className={"kslplus-beschreibung-content" + (this.props.kennzahlErg ? " kslplus-ke-vgl-bk" : "")}>
                                                <div className="content" dangerouslySetInnerHTML={{ __html: this.props.kennzahl.erlTextVgl }}></div>
                                            </Col>
                                        </Row>
                                    </Collapse>
                                </div>
                            }

                            {tabItems.navItems.length > 0 &&
                                <div>
                                    <button
                                        className={"kslplus-beschreibung-toggle" + (this.state.vbTabsActive ? " active" : "")}
                                        onClick={() => this.setState({ vbTabsActive: !this.state.vbTabsActive })}>
                                        <div className="kslplus-beschreibung-text">
                                            Datenreiter
                                        </div>
                                        <div className="rotate90">
                                            <svg
                                                className={"kslplus-beschreibung-icon" + (this.state.vbTabsActive ? " expanded" : "")}
                                                viewBox="6 0 12 24"
                                            >
                                                <polygon points="8 0 6 1.8 14.4 12 6 22.2 8 24 18 12" />
                                            </svg>
                                        </div>

                                    </button>


                                    <Collapse
                                        isOpen={this.state.vbTabsActive}
                                        className={"kslplus-collapse-gradient " + (this.state.vbTabsActive ? " active" : "")}>

                                        <Nav tabs className={"kslplus-haushaltstab-wrapper-top kslplus-haushaltstab-wrapper-middle kslplus-haushaltstab-wrapper-very-bottom " + (this.props.kennzahlErg ? " kslplus-ke-vgl-bk" : "")} >
                                            {tabItems.navItems}
                                        </Nav>

                                        <TabContent className={"kslplus-haushaltstab-wrapper-top kslplus-haushaltstab-wrapper-middle kslplus-haushaltstab-wrapper-very-bottom " + (this.props.kennzahlErg ? " kslplus-ke-vgl-bk" : "")} activeTab={this.state.activeKZTab}>
                                            {tabItems.contentItems}
                                        </TabContent>
                                    </Collapse>
                                </div>
                            }
                            {this.createGZItem()}
                            {sammelgraphItems}
                            {graphItems}
                            {zusatzgraphItems}
                            {zusatzsammelgraphItems}
                        </div>
                    }
                </div>
            </div>
        );
    }
}